<div class="container" fxLayout="column" fxLayoutGap="15px">
  <div class="header-container" fxLayout="row" fxLayoutAlign="space-between">{{ 'ANALYST_LAST_VISIT' | translate }} {{rating.ratingDate | date : 'MM/yyyy'}}. {{ 'RATING_DESCRIPTION' | translate }}
  </div>
  <div class="ratings-container">
    <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'STORE_RATINGS' | translate }}</h2>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'CEILING_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreCeiling?.value"
                           *ngIf="ratingStoreCeiling; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'CHECKSTAND_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreCheckstand?.value"
                           *ngIf="ratingStoreCheckstand; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'EXTERIOR_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreExterior?.value"
                           *ngIf="ratingStoreExterior; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'FLOOR_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreFloor?.value"
                           *ngIf="ratingStoreFloor; else notAvailable"></mtn-star-rating>
        </div>
      </div>
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'REFRIGERATION_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreRefrigeration?.value"
                           *ngIf="ratingStoreRefrigeration; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'SHELVING_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreShelving?.value"
                           *ngIf="ratingStoreShelving; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'VISIBILITY_FROM_ROAD' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreVisibility?.value"
                           *ngIf="ratingStoreVisibility; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'WALL_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingStoreWall?.value"
                           *ngIf="ratingStoreWall; else notAvailable"></mtn-star-rating>
        </div>
      </div>
    </div>
  </div>
  <div class="ratings-container">
    <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'PARKING_LOT_RATINGS' | translate }}</h2>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'GENERAL_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingParkingCondition?.value"
                           *ngIf="ratingParkingCondition; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'INGRESS_EGRESS' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingParkingIngressEgress?.value"
                           *ngIf="ratingParkingIngressEgress; else notAvailable"></mtn-star-rating>
        </div>
      </div>
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'LIGHTING' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingParkingLighting?.value"
                           *ngIf="ratingParkingLighting; else notAvailable"></mtn-star-rating>
        </div>
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'TRAFFIC_FLOW' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingParkingFlow?.value"
                           *ngIf="ratingParkingFlow; else notAvailable"></mtn-star-rating>
        </div>
      </div>
    </div>
  </div>
  <div class="ratings-container">
    <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'COTENANT_RATINGS' | translate }}</h2>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'EXTERIOR_CONDITION' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingCotenantExterior?.value"
                           *ngIf="ratingCotenantExterior; else notAvailable"></mtn-star-rating>
        </div>
      </div>
      <div fxLayout="column" fxLayoutGap="5px">
        <div class="rating-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>{{ 'SYNERGY' | translate }}</span>
          <div fxFlex></div>
          <mtn-star-rating [count]="ratingCotenantSynergy?.value"
                           *ngIf="ratingCotenantSynergy; else notAvailable"></mtn-star-rating>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notAvailable>
  <span class="color-muted">{{ 'NOT_AVAILABLE' | translate }}</span>
</ng-template>
